<template lang="pug">
    el-dialog(title="修改名单",:fullscreen="false",:visible.sync="visible" width="80%" :append-to-body='true' :modal-append-to-body='false' @close="closeForm()")
        el-row(v-if='visible')
            el-col(:span="12")
                el-card(shadow="never")
                    div(slot="header")
                        el-row
                            el-col(:span='22')
                                el-input(v-model='keyWords' clearable='', style='width:80%;' placeholder="请输入姓名/级别/手机号码")
                            el-col(:span='2')
                                el-button(@click="sizeChangeHandle" style='float:right;' icon='el-icon-search') 查询
                    div
                        el-table(ref="leftData" row-key="id"  :data="leftData" border v-el-table-infinite-scroll="currentChangeHandleLeftMember" @selection-change="checkLeftMemberAll" max-height="300" )
                            el-table-column(prop="name" label="姓名" align='center')
                            el-table-column(prop="gender" label="性别" align='center' )
                                template(slot-scope="scope")
                                    font(v-if="scope.row.gender === 0") 男
                                    font(v-if="scope.row.gender === 1") 女
                            el-table-column(prop="level" label="级别" align='center' )
                            el-table-column(prop="mobile" label="手机号码" align='center' )
                            el-table-column(type="selection" align='center' reserve-selection=true)
            el-col(:span="12")
                el-card(shadow="never")
                    div(slot="header")
                        font.font_label 已选择的人员
                    div
                        el-table(:data="rightData" border max-height="317")
                            el-table-column(prop="name" label="姓名" align='center')
                            el-table-column(prop="gender" label="性别" align='center' )
                                template(slot-scope="scope")
                                    font(v-if="scope.row.gender === 0") 男
                                    font(v-if="scope.row.gender === 1") 女
                            el-table-column(prop="level" label="级别" align='center' )
                            el-table-column(prop="mobile" label="手机号码" align='center' )
                            el-table-column(fixed="right" label="操作" align='center')
                                template(slot-scope="scope")
                                    i(class="el-icon-error" style='color:#f56c6c;cursor:pointer;font-size: 18px;' @click.prevent="deleteRowLeftMember(scope.$index, rightData)")
        span.dialog-footer(slot="footer")
            el-button(@click="addEnrollClubMember" type="primary") 确 定
            el-button(@click="visible=false") 取 消
</template>
<script>
import {
  saveAttendanceList,
  getEnrollClubMemberList2,
  getClubDoubleSortMemberList
} from '@/api/fqSelf/index.js';
export default {
  data () {
    return {
      visible: false,
      leftData: [], //添加队员左侧列表
      rightData: [], //添加队员右侧列表
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      keyWords: null,
      round: null,
      transmitRow: {},
      rightDataEnroll: [] //当前俱乐部已参赛队员
    };
  },
  methods: {
    openFullScreen () {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    //添加队员
    init (row, round) {
      this.keyWords = null;
      this.transmitRow = row;
      this.round = round;
      this.visible = true;
      this.leftData = [];
      this.rightData = [];
      this.rightDataEnroll = [];
      this.pageIndex = 1;
      this.getLeftData();
    },
    getLeftData () {
      let params = {
        ctId: this.transmitRow.ctId,
        clubId: this.transmitRow.clubId,
        round: this.round,
        keyWords: this.keyWords
      };
      getEnrollClubMemberList2(params).then(data => {
        if (data && data.code === 0) {
          if (this.pageIndex === 1) {
            this.leftData = data.list;
          } else {
            this.leftData = this.leftData.concat(data.list);
          }
          this.totalPage = data.list.length;
          //查询俱乐部已报名队员
          getClubDoubleSortMemberList(params).then(data => {
            if (data && data.code === 0) {
              if (data.list && data.list.length > 0) {
                let arr = data.list;
                this.rightData = arr;
                this.rightDataEnroll = arr;
                arr.forEach(e => {
                  this.leftData.forEach(b => {
                    if (e.id === b.id) {
                      this.$refs.leftData.toggleRowSelection(b, true);
                    }
                  });
                });
                console.log('右侧报名选中人员：', this.rightData);
                console.log('右侧报名选中人员1：', this.rightDataEnroll);
              }
            }
          });
        } else {
          this.leftData = [];
          this.totalPage = 0;
        }
      });
    },
    //选中添加队员左侧列表
    checkLeftMemberAll (val) {
      this.rightData = val;
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = 10;
      this.pageIndex = 1;
      this.getLeftData();
    },
    // 当前页
    currentChangeHandleLeftMember (val) {
      console.log(
        '触底事件：',
        this.pageIndex,
        Math.ceil(this.totalPage / this.pageSize)
      );
      let flag = true;
      if (this.pageIndex) {
        if (this.pageIndex < Math.ceil(this.totalPage / this.pageSize)) {
          this.pageIndex++;
        } else {
          flag = false;
        }
      } else {
        this.pageIndex = 1;
      }
      if (flag) {
        this.getLeftData();
      }
    },
    deleteRowLeftMember (index, rows) {
      this.$refs.leftData.toggleRowSelection(rows[index], false);
      rows.splice(index, 1);
    },
    //添加俱乐部参赛会员
    addEnrollClubMember () {
      if (this.rightData.length < 6) {
        this.$message.error('不满6人，请重新设置!');
      } else if (this.rightData.length === 6) {
        // let judge = this.judgeChange();
        // if (!judge) {
        //   return false;
        // }
        let idArr = this.rightData.map(item => {
          return item.id;
        });
        let firstDoubles = idArr.splice(0, 2).join(',');
        let secondDoubles = idArr.splice(0, 2).join(',');
        let thirdDoubles = idArr.splice(0, 2).join(',');
        let params = [{
          ctId: this.transmitRow.ctId,
          cbId: this.transmitRow.clubId,
          round: this.round,
          isBefore: true,
          firstDoubles,
          secondDoubles,
          thirdDoubles
        }];
        saveAttendanceList(params).then(data => {
          this.openFullScreen();
          if (data && data.code === 0) {
            this.$message.success('操作成功!');
            this.visible = false;
            this.rightData = [];
            this.$emit('refreshList');
          } else {
            this.$message.success('操作失败!');
          }
          this.loading.close();
        });
      } else {
        this.$message.error('超过6人，请重新设置!');
      }
    },
    closeForm () {
      this.visible = false;
    },
    judgeChange () {
      //新添加的队员
      let newList = [];
      this.rightData.forEach(e => {
        //标记新添加的
        let newFlag = true;
        this.rightDataEnroll.forEach(b => {
          if (e.id === b.id) {
            newFlag = false;
          }
        });
        if (newFlag) {
          newList.push(e);
        }
      });

      //此次删除的队员
      let deleteList = [];
      this.rightDataEnroll.forEach(e => {
        //标记新添加的
        let deleteFlag = true;
        this.rightData.forEach(b => {
          if (e.id === b.id) {
            console.log('报名人员相同：', e.id, b.id);
            deleteFlag = false;
          }
        });
        if (deleteFlag) {
          deleteList.push(e);
        }
      });
      if (newList.length === 0 && deleteList.length === 0) {
        this.$message.error('没有要添加或删除的人员!');
        return false;
      } else {
        return true;
      }
    }
  }
};
</script>
